import { put, select } from "redux-saga/effects";
import { API } from 'aws-amplify';
import { getResponseData } from '../../utils/apiHelpers';

import moment from "moment";

import * as actions from "../actions";
import * as selectors from "../selectors/selectors";
import { handleApiError } from '../../utils/apiErrorHandler';

function* kryInstruksiesData(datums) {
    try {
        // console.log(datums.join(","));
        let apiName = 'API_Aktiwiteite';
        let path = `/instruksies?detail=thumbnail&datums=${encodeURIComponent(datums.join(","))}`;
        const response = yield API.get(apiName, path, { response: true });
        // console.log(response);
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            return [];
        } else {
            return getResponseData(response, []);
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);

        throw {
            error: errordata,
            easymessage: "Iets het skeefgeloop...",
            status: errordata.code,
            message: errordata.message
        };
        // return [errordata, "Iets het skeefgeloop...", errordata.code, errordata.message];
    }
}

export function* getInstruksiesCardsSaga(action) {
    yield put(actions.setInstruksieCardsLoading());
    // console.log(action);
    const datadatums = yield select(selectors.instruksiesGekry);
    const instruksieKryDatum = moment.utc(yield select(selectors.instruksieKryDatum)).format();
    const instruksieCards = [...(yield select(selectors.instruksiesCards))];

    var datums = [...datadatums];
    // console.log("datums", datums);
    var krydatums = [];

    if (datums.length < 1) {
        try {
            krydatums.push(instruksieKryDatum);
            const result = yield* kryInstruksiesData(krydatums);
            datums.push({ timestamp: moment().unix(), datum: moment.utc().format() });
            yield put(actions.setInstruksiesCards(result));
            yield put(actions.setInstruksieDatumsGekry(datums));
        } catch (error) {
            console.log(error);
            yield put(actions.getInstruksiesCardsFailed(error, error?.easymessage, error?.status, error?.message));
        }
    } else {
        if (Array.isArray(instruksieKryDatum)) {
            for (const datum of instruksieKryDatum) {
                const index = datums.map(item => moment(item.datum).format("MM/DD/Y")).indexOf(moment(datum).format("MM/DD/Y"));
                if (index === -1) {
                    krydatums.push(datum);
                } else {
                    if (moment(datums[index].timestamp).add(2, "h") < moment()) {
                        datums.splice(index, 1);
                        krydatums.push(datum);
                    }
                }
            }
        } else {
            const index = datums.map(item => moment(item.datum).format("MM/DD/Y")).indexOf(moment(instruksieKryDatum).format("MM/DD/Y"));
            if (index === -1) {
                krydatums.push(instruksieKryDatum);
            } else {
                if (moment(datums[index].timestamp).add(2, "h") > moment()) {
                    datums.splice(index, 1);
                    krydatums.push(instruksieKryDatum);
                }
            }
        }
        try {
            // console.log("krydatums", krydatums);
            if (krydatums.length > 0) {
                const results = yield* kryInstruksiesData(krydatums);
                for (const datum of krydatums) {
                    datums.push({ timestamp: moment().unix(), datum: moment.utc(datum).format() });
                }
                for (const result of results) {
                    const index = instruksieCards.map(item => item.id).indexOf(result.id);
                    if (index === -1) {
                        instruksieCards.push(result);
                    } else {
                        instruksieCards[index] = result;
                    }
                }
            }
            yield put(actions.setInstruksiesCards(instruksieCards));
            yield put(actions.setInstruksieDatumsGekry(datums));
        } catch (error) {
            console.log(error);
            yield put(actions.getInstruksiesCardsFailed(error, error?.easymessage, error?.status, error?.message));
        }
    }
}

function* kryInstruksie(id) {
    try {
        let apiName = 'API_Aktiwiteite';
        let path = `/instruksies?id=${id}&detail=detailed`;
        const response = yield API.get(apiName, path, { response: true });
        // console.log(response);
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            throw new Error({
                error: {},
                easymessage: "Iets het skeefgeloop...",
                status: 404,
                message: "Die instruksie kon nie gevind word nie."
            });
        } else {
            return getResponseData(response, [])[0];
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);

        throw {
            error: errordata,
            easymessage: "Iets het skeefgeloop...",
            status: errordata.code,
            message: errordata.message
        };
    }
}

export function* instrInvulGetInstruksieSaga(action) {
    try {
        yield put(actions.instrInvulSetInstruksieLoading());

        const results = yield* kryInstruksie(action.id);
        // console.log(results);
        yield put(actions.instrInvulSetInstruksie(results));
    } catch (error) {
        console.log(error);
        yield put(actions.instrInvulGetInstruksieFailed(error, error?.easymessage, error?.status, error?.message));
    }
}

function* kryInstruksieIngevul(id) {
    try {
        let apiName = 'API_Aktiwiteite';
        let path = `/instruksietransaksies?instruksie=${id}`;
        const response = yield API.get(apiName, path, { response: true });
        // console.log(response);
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            throw new Error({
                error: {},
                easymessage: "Iets het skeefgeloop...",
                status: 404,
                message: "Die instruksie kon nie gevind word nie."
            });
        } else {
            return getResponseData(response, []);
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);

        throw {
            error: errordata,
            easymessage: "Iets het skeefgeloop...",
            status: errordata.code,
            message: errordata.message
        };
    }
}

function* kryInstruksieDetails(id) {
    try {
        let apiName = 'API_Aktiwiteite';
        let path = `/instruksies?id=${id}&detail=opsomming`;
        const response = yield API.get(apiName, path, { response: true });
        // console.log(response);
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            throw new Error({
                error: {},
                easymessage: "Iets het skeefgeloop...",
                status: 404,
                message: "Die instruksie kon nie gevind word nie."
            });
        } else {
            return getResponseData(response, [])[0];
        }
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);

        throw {
            error: errordata,
            easymessage: "Iets het skeefgeloop...",
            status: errordata.code,
            message: errordata.message
        };
    }
}

export function* instrInvulGetInstruksieIngevulSaga(action) {
    try {
        yield put(actions.instrInvulSetInstruksieLoading());

        const ingevulresult = yield* kryInstruksieIngevul(action.id);
        const leeresult = yield* kryInstruksieDetails(action.id);
        // console.log(ingevulresult, leeresult);
        yield put(actions.instrInvulSetInstruksieIngevul({ ingevul: ingevulresult, leeg: leeresult }));
    } catch (error) {
        console.log(error);
        yield put(actions.instrInvulGetInstruksieIngevulFailed(error));
    }
}